// extracted by mini-css-extract-plugin
module.exports = {"main-component":"metricAdoption_main-component__2MjYo"};